<template>
    <div>
        <div class="container space">
            <div class="row ">
                <div class="col col-lg-12 col-sm-12">
                    <div class="section-title-s3">
                        <span>Case Study</span>
                        <h2>{{caseStudy.client}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <section>
            <div  class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <carousel :per-page="1">
                            <slide  v-for="(image, i) in caseStudy.photos" :key="i">
                                <img :src="image" class="box-slider-img" />
                            </slide>
                        </carousel>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container space">
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h4>{{caseStudy.title}}</h4>
                        <p>{{caseStudy.content}}</p>
                    </div>

                </div>
            </div>
        </section>
        <section>
            <div class="container space">
                <div class="row">
                    <div class="col-md-12  ">
                        <h4 class="text-left">Related Projects</h4>
                    </div>
                    <div class="col-sm-12 project-section project-padding">
                        <div class="projects-grids">
                            <project v-for="(item, i) in relatedCases" :key='i' :project="item"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>

</template>

<script>
import cases from './caseStudies'
import project from './sections/project'
export default {
    name: 'detail',
    components: {
        project
    },
    computed: {
        relatedCases() {
           return cases.filter(item => item.slug != this.$route.params.slug).slice(0, 3)
        },
        caseStudy(){
            const slug = this.$route.params.slug;
            return cases.filter(item => item.slug === slug)[0]
        }
    }

}
</script>
<style scoped>
 .box-slider-img {
     object-fit:cover;
     width: 100%;
     height: 70vh;
 }
 .project-section {
    padding-bottom: 90px;
}
.section-padding {
    padding: 120px 0;
}
.project-grids {
    margin: 0 -15px;
}
</style>
